import { GetUserRequest } from "@/Stub/V1";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import { UsersApiClient } from "@/Service/Api/V1/ApiClients/UsersApiClient";

export type useGetUserParams = {
    requestParams: GetUserRequest
    enabled?: boolean
    savePreviousData?: boolean
};

export const useGetUser = ({ requestParams, enabled, savePreviousData }: useGetUserParams) => useQuery({
    ...QueryKeys.users.detail(requestParams),
    queryFn: async () => await UsersApiClient.getUser(requestParams),
    enabled,
    gcTime: 0,
    placeholderData: savePreviousData ? keepPreviousData : undefined
});